function fmt(locale, timeZone, opts) {
    return new Intl.DateTimeFormat(locale, { timeZone, ...opts })
}

const tokenFormatters = (locale, timeZone, hour12) => ({
    // Weekday
    Wn: (d) => fmt(locale, timeZone, { weekday: "narrow" }).format(d), // L
    W: (d) => fmt(locale, timeZone, { weekday: "short" }).format(d), // L, R, P...
    WW: (d) => fmt(locale, timeZone, { weekday: "long" }).format(d), // laupäev

    // Day
    d: (d) => fmt(locale, timeZone, { day: "numeric" }).format(d),
    dd: (d) => fmt(locale, timeZone, { day: "2-digit" }).format(d),

    // Month (name or number)
    M: (d) => fmt(locale, timeZone, { month: "numeric" }).format(d),
    MM: (d) => fmt(locale, timeZone, { month: "2-digit" }).format(d),
    MMM: (d) => fmt(locale, timeZone, { day: '2-digit', month: "short" }).format(d).substring(3), // okt // et locale results in full month name if day is not specified
    MMMM: (d) => fmt(locale, timeZone, { month: "long" }).format(d), // oktoober

    // Year
    yyyy: (d) => fmt(locale, timeZone, { year: "numeric" }).format(d),

    // Time (24h by default, unless hour12 is true)
    H: (d) => fmt(locale, timeZone, { hour: "numeric", hour12 }).format(d),
    HH: (d) => fmt(locale, timeZone, { hour: "2-digit", hour12 }).format(d),
    m: (d) => fmt(locale, timeZone, { minute: "numeric", hour12 }).format(d),
    mm: (d) => ("0" + fmt(locale, timeZone, { minute: "2-digit", hour12 }).format(d)).slice(-2), // https://stackoverflow.com/questions/33401520/intl-datetimeformat-options-hash-getting-leading-zeros-with-2-digit
    s: (d) => fmt(locale, timeZone, { second: "numeric", hour12 }).format(d),
    ss: (d) => ("0" + fmt(locale, timeZone, { second: "2-digit", hour12 }).format(d)).slice(-2),
})

/**
 * formatDate(date, pattern, options)
 * - pattern: tokens like "yyyy-MM-dd" or "Wn, d. MMM, HH:mm"
 */
export function formatDate(date, pattern, options = {}) {
    const d = date instanceof Date ? date : new Date(date)
    const { locale, timeZone, hour12 = false } = options

    const tokens = tokenFormatters(locale ?? "et", timeZone, hour12)

    // longest tokens first so MMMM beats MMM
    const TOKEN_RE = /(WW|Wn|W|dd|d|MMMM|MMM|MM|M|yyyy|HH|H|mm|m|ss|s)/g;

    return pattern.replace(TOKEN_RE, (match) => tokens[match](d));
}
